import { User } from "../../Module_cms/Auth/Domain/Model/User";

const USER_KEY = "userData";
export const UserDataStorage = {
  save: (user: any) => {
    if (!user) return;
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  updateToken: (newToken: string ) => {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return;
     console.log("newToken", newToken);
     const user: any = JSON.parse(raw);
     user.jwToken = newToken;

     localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  get: (): any | null => {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) as User : null;
  },
  clear: () => {
    localStorage.removeItem(USER_KEY);
  },
};